import $axios from './request';
// 登录
export const login = (data) => {
    return $axios({
        url: '/slacklogin/login',
        method: 'post',
        data,
    })
}
//绑定
export const bing = (data) => {
    return $axios({
        url: '/wkman/bing',
        method: 'post',
        data,
    })
}

// 好友列表
export const showfriends = (data) => {
    return $axios({
        url: '/slacklogin/showfriends',
        method: 'post',
        data,
    })
}
//用户下拉列表
export const allusers = (data) => {
    return $axios({
        url: '/slacklogin/allusers',
        method: 'post',
        data,
    })
}
//添加好友列表
export const addfriends = (data) => {
    return $axios({
        url: '/slacklogin/addfriends',
        method: 'post',
        data,
    })
}
//删除好友
export const removefriends = (data) => {
    return $axios({
        url: '/slacklogin/removefriends',
        method: 'post',
        data,
    })
}
//添加聊天记录
export const sending = (data) => {
    return $axios({
        url: '/slacklogin/sending',
        method: 'post',
        data,
    })
}
//消息记录
export const chatlog = (data) => {
    return $axios({
        url: '/slacklogin/chatlog',
        method: 'post',
        data,
    })
}
//返回未读消息数量
export const unread = (data) => {
    return $axios({
        url: '/slacklogin/unread',
        method: 'post',
        data,
    })
}
//创建群聊
export const creategroup = (data) => {
    return $axios({
        url: '/wkman/creategroup',
        method: 'post',
        data,
    })
}
//群聊列表
export const grouplist = (data) => {
    return $axios({
        url: '/slacklogin/grouplist',
        method: 'post',
        data,
    })
}
//询盘群聊列表
export const rfqGroupList = (data) => {
    return $axios({
        url: '/slacklogin/rfqGroupList',
        method: 'post',
        data,
    })
}
//群聊记录
export const groupchat = (data) => {
    return $axios({
        url: '/slacklogin/groupchat',
        method: 'post',
        data,
    })
}
//群聊信息
export const groupinfo = (data) => {
    return $axios({
        url: '/wkman/groupinfo',
        method: 'post',
        data,
    })
}
//修改群聊信息
export const groupedit = (data) => {
    return $axios({
        url: '/wkman/groupedit',
        method: 'post',
        data,
    })
}
//退出群聊&移出群聊
export const exitgroup = (data) => {
    return $axios({
        url: '/wkman/exitgroup',
        method: 'post',
        data,
    })
}
//解散群聊
export const dissolvegroup = (data) => {
    return $axios({
        url: '/wkman/dissolvegroup',
        method: 'post',
        data,
    })
}
//修改消息状态
export const msgread = (data) => {
    return $axios({
        url: '/slacklogin/msgread',
        method: 'post',
        data,
    })
}
//修改群聊状态
export const groupread = (data) => {
    return $axios({
        url: '/wkman/groupread',
        method: 'post',
        data,
    })
}
//搜索
export const search = (data) => {
    return $axios({
        url: '/wkman/search',
        method: 'post',
        data,
    })
}
//临时聊天
export const temporary = (data) => {
    return $axios({
        url: '/slacklogin/temporary',
        method: 'post',
        data,
    })
}
//临时聊天
export const screen = (data) => {
    return $axios({
        url: '/wkman/screen',
        method: 'post',
        data,
    })
}
//删除私聊
export const delrivatechat = (data) => {
    return $axios({
        url: '/wkman/delprivatechat',
        method: 'post',
        data,
    })
}
//删除群聊
export const delgroupchat = (data) => {
    return $axios({
        url: '/wkman/delgroupchat',
        method: 'post',
        data,
    })
}
//收藏
export const asterisk = (data) => {
    return $axios({
        url: '/wkman/asterisk',
        method: 'post',
        data,
    })
}
//对象发送聊天记录
export const Getmessagerecording = (data) => {
    return $axios({
        url: '/wkman/messagerecording',
        method: 'post',
        data,
    })
}
//获取客服
export const customerservice = (data) => {
    return $axios({
        url: '/wkman/customerservice',
        method: 'post',
        data,
    })
}
//获取发送对象的聊天记录
export const context = (data) => {
    return $axios({
        url: '/wkman/context',
        method: 'post',
        data,
    })
}

//读取未读私信消息
export const getMyMsg = (data) => {
    return $axios({
        url: '/wkman/getMyMsg',
        method: 'post',
        data,
    })
}
//读取未读群聊消息
export const getMyGroupMsg = (data) => {
    return $axios({
        url: '/wkman/getMyGroupMsg',
        method: 'post',
        data,
    })
}

//获取好友的host
export const getfriendAddress = (data) => {
    return $axios({
        url: '/slacklogin/getfriendAddress',
        method: 'post',
        data,
    })
}
//获取未读消息总数
export const getMsgCount = (data) => {
    return $axios({
        url: '/wkman/getMsgCount',
        method: 'post',
        data,
    })
}

//获取未读消息总数
export const slackreg = (data) => {
    return $axios({
        url: '/slacklogin/slackreg',
        method: 'post',
        data,
    })
}


//查询用户信息和owner信息
export const getUserOwner = (data) => {
    return $axios({
        url: '/slacklogin/getUserOwner',
        method: 'post',
        data,
    })
}
//全部已读
export const allread = (data) => {
    return $axios({
        url: '/slacklogin/allread',
        method: 'post',
        data,
    })
}
//获取当前站点的聊天记录
export const websiteChatlog = (data) => {
    return $axios({
        url: '/api/website/chatlog',
        method: 'post',
        data,
    })
}
//独立站-设置消息为已读
export const websiteMsgread = (data) => {
    return $axios({
        url: '/api/website/msgread',
        method: 'post',
        data,
    })
}
//独立站-用户未读消息数
export const websitegetMsgCount = (data) => {
    return $axios({
        url: '/api/website/getMsgCount',
        method: 'post',
        data,
    })
}
//接待分配(登录用户)
export const assign = (data) => {
    return $axios({
        url: '/api/customerServ/assign',
        method: 'post',
        data,
    })
}
//独立站-发送消息
export const sendMsg = (data) => {
    return $axios({
        url: '/api/website/sendMsg',
        method: 'post',
        data,
    })
}
//独立站-登录后绑定游客
export const bindTourist = (data) => {
    return $axios({
        url: '/api/website/bindTourist',
        method: 'post',
        data,
    })
}
//站点-邀请平台介入
export const platformIntervention = (data) => {
    return $axios({
        url: '/api/website/platformIntervention',
        method: 'post',
        data,
    })
}
//添加好友时获取所有用户列表
export const Messageallusers = (data) => {
    return $axios({
        url: '/api/message/allusers',
        method: 'post',
        data,
    })
}
//接待方的聊天记录
export const customerServLog = (data) => {
    return $axios({
        url: '/api/customerServ/chatlog',
        method: 'post',
        data,
    })
}
// 服务列表
export const sessionList = (data) => {
    return $axios({
        url: '/api/customerServ/sessionList',
        method: 'post',
        data,
    })
}
let baseURL;
import { useDemoStore } from '@/pinia/index'
const store = useDemoStore()
let isDev = store.context;
if (isDev == 0) { //测试
    baseURL = "http://d-api.files99.com/v2";
} else if (isDev == 1) { //调试
    if (store.server == 'cn') { //中国
        baseURL = "https://cn-d-api-produce.files99.com/v2"
    } else if (store.server == 'de') { //德国
        baseURL = "https://de-d-api-produce.kernal.net/v2"
    } else if (store.server == 'usWest') { //美国西部
        baseURL = "https://us-d-api-produce.kernal.net/v2"
    } else if (store.server == 'usEst') { //美国东部
        baseURL = "https://use-d.salesdeep.com/v2"
    }
    else if (store.server == 'br') { //巴西
        baseURL = "https://br-d-api-produce.kernal.net/v2"
    } else if (store.server == 'sg') { //新加坡
        baseURL = "https://sg-d-api-produce.kernal.net/v2"
    }
} else if (isDev == 2) { //生产
    if (store.server == 'cn') { //中国
        baseURL = "https://cn-d-api-produce.files99.com/v2"
    } else if (store.server == 'de') { //德国
        baseURL = "https://de-d.salesdeep.com/v2"
    } else if (store.server == 'usWest') { //美国西部
        baseURL = "https://us-d.salesdeep.com/v2"
    } else if (store.server == 'usEst') { //美国东部
        baseURL = "https://use-d.salesdeep.com/v2"
    }
    else if (store.server == 'br') { //巴西
        baseURL = "https://br-d.salesdeep.com/v2"
    } else if (store.server == 'sg') { //新加坡
        baseURL = "https://sg-d.salesdeep.com/v2"
    }
}
//获取客户关联的供应商
export const getMyRfqVendor = (data) => {
    return $axios({
        baseURL: baseURL + '/Polling/getMyRfqVendor',
        method: 'post',
        data,
    })
}